import { createFileRoute } from "@tanstack/react-router";

import { useMe } from "../../../lib/session";
import { RouteFallback } from "../../../shell/RouteFallback";
import { AccountPanel } from "../../../workspaces/settings/AccountPanel";

export const Route = createFileRoute("/_console/settings/")({
  component: AccountRoute,
});

function AccountRoute() {
  // Already resolved and cached by the shell's one identity call; this reads it, never
  // re-asks it.
  const me = useMe();
  if (!me.data) return <RouteFallback />;
  return <AccountPanel session={me.data} />;
}
